// images module API
import initSmartImages from "Modules/SmartImage/SmartImageManager";

// API
export default {
  initSmartImages: initSmartImages 
}